<template>
  <div class="AddressInfo">
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane label="服务预约地址" >
        <span slot="label"><p class="el-icon-arrow-left back-icon" @click="back()"></p> 服务预约地址 </span>
        <el-divider class="info-divider"></el-divider>
        <div class="address-list info-background" v-for="(a,i) in addressList" :key="i">
          <el-row :gutter="20" align="middle" type="flex">
            <el-col :span="18"><div class="info-add" @click="chooseAddress(a)">
              <p class="list_username">{{a.name}}</p>
              <p class="list_phone">{{a.phone}}</p>
              <img src="../assets/default.png" alt="" v-if="a.selected==1" class="default-img">
              <div class="list_address">{{a.address}}</div>
            </div></el-col>
<!--            <el-col :span="4">-->
<!--              <div class="el-icon-edit" @click="editAddress(a)"> </div>-->
<!--            </el-col>-->
            <el-col :span="2">
              <div class="el-icon-edit" @click="editAddress(a)"> </div>
            </el-col>
            <el-col :span="2" :push="1">
              <div class="el-icon-delete" @click="deleteAddress(a,i)"></div>
            </el-col>
          </el-row>

          <el-divider class="info-divider"></el-divider>
        </div>
        <el-button type="primary" round @click="newAddress()">新增地址</el-button>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
    export default {
      name: "addressInfo",
      data(){
        return{
          addressList: [],
          unionid: ''
        }
      },
      methods:{
          // 路由返回Index
          back(){
              this.$router.push({
                  name:"Index",
              })
          },
          chooseAddress(a){
            this.$router.push({
              name:"Index",
              params: {
                  contact: a
              }
            })
          },
          newAddress(){
            this.$router.push({
              name:"AddressEdit",
            })
          },
          editAddress(a){
            this.$router.push({
              name:"AddressEdit",
              params: {
                contact: a
              }
            })
          },
          deleteAddress(a,i){
            this.$confirm('确认删除该地址', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              showClose: false,
              customClass: 'message-logout'
            }).then((action) => {
              if(action === 'confirm'){
                // 删除
                this.$axios.delete(this.$baseURL + `/contact/`+a.id)
                  .then(()=> {
                      this.addressList.splice(i,1)
                      this.$message({
                          type: 'success',
                          message: '删除成功!'
                      })
                  })
                  .catch(error=> {
                      console.log(error)
                  })
              }
            }).catch(() => {
                // DO NOTHING
            })
          }
      },
      created() {
        this.unionid = window.localStorage.getItem("fastunionid")
        // 查询联系人列表
        this.$axios.get(this.$baseURL + `/contact/` + this.unionid)
          .then(data=> {
            this.addressList = data.data
          })
          .catch(error=> {
            console.log(error)
        })
      },
      activated() {
        // 若是新增地址，重新获取列表
        if(this.$route.params.refresh){
          this.$axios.get(this.$baseURL + `/contact/` + this.unionid)
            .then(data=> {
                this.addressList = data.data
            })
            .catch(error=> {
                console.log(error)
            })
        }
      }
    }
</script>

<style scoped>
  .AddressInfo {
    height: 100%;
  }
  .el-tabs{
    height: 100%;
    position: relative;
    overflow: scroll;
  }
  .info-add {
    text-align: left;
    margin: 10px 0px;
  }
  .info-add p {
    display:inline-block;
    font-size: 15px;
    margin: 0px 15px 6px 15px;
    color: #333333;
  }
  .list_username {
    font-weight: 600;
  }
  .list_address {
    margin: 0px 0px 0px 15px;
    color: #999999;
    font-size: 12px;
  }
  .default-img {
    float: right;
    position: relative;
    width: 30px;
    height: 30px;
    top: -5px;
    right: 5px;
  }
</style>
<style>

</style>
